"use client";

// packages/eden-form-parts/src/components/TextArea.jsx
import { useContext, forwardRef } from "react";
import styled from "styled-components";
import { sharedInputCss } from '../utils/sharedCss.js';
import {
  ValidityStateContext,
  IdContext,
  DescribedByContext
} from '../utils/context.js';
import { jsx } from "react/jsx-runtime";
var InternalUseOnlyTextArea = styled.textarea`
  ${sharedInputCss};
  overflow: auto;
  margin: 0;
  height: 8rem;
`;
var TextAreaComponent = ({ "aria-describedby": ariaDescribedBy, id, ...props }, ref) => {
  const validityStateContext = useContext(ValidityStateContext);
  const idContext = useContext(IdContext);
  const describedByContext = useContext(DescribedByContext);
  return /* @__PURE__ */ jsx(
    InternalUseOnlyTextArea,
    {
      "aria-describedby": ariaDescribedBy ? ariaDescribedBy : describedByContext,
      id: id ? id : idContext,
      $validityState: validityStateContext,
      ...props,
      ref
    }
  );
};
var TextArea = forwardRef(TextAreaComponent);
TextArea.displayName = "TextArea";
TextArea.isInput = true;
var TextArea_default = TextArea;
export {
  InternalUseOnlyTextArea,
  TextArea_default as default
};
